import SideNav from "./sidenav";
import React, { useState, useEffect, Component } from "react";
import PaymentBg from "../images/payments.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Download from "../images/downloadicon.png";
import Check from "../images/check.png";
import Mobilenav from "./mobiledropdwn";
import "./paymentTypes.css";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import { RiHonourLine } from "react-icons/ri";
import Footer from "./footer";
import AOS from 'aos';

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const PaymentTypes = () => {
 

  const [active, setActive] = useState("Programmed Withdrawals (Lump Sum)");

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [types, setTypes] = useState([]);
  const [enblock, setEnblock] = useState([]);
  const [programmedWithdrawals, setProgrammedWithdrawals] = useState([]);
  const [reitreeAnnunity, setRetireeAnnunity] = useState([]);
  const [medical, setMedical] = useState([]);
  const [temporaryAccess, setTemporaryAccess] = useState([]);
  const [foreigner, setForeigner] = useState([]);
  const [NSITF, setNsitf] = useState([]);
  const [legacy, setLegacy] = useState([]);
  const [avc, setAvc] = useState([]);
  const [db, setDb] = useState([]);

    
                useEffect( () => {
                                             AOS.init({
                                                offset: 0,
                                                duration: 1000,
                                                once: true
                                         });
                                                          
                                                              
                                         }, [])

  useEffect(() => {
     window.scrollTo(0, 0);
    client
      .query({
        query: gql`
          query NewQuery {
            pages {
              edges {
                node {
                  id
                  PT {
                    hero {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    heromobile {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    type {
                      description
                      link
                      name
                      requirement {
                        item
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);
        setHeroBanner(result.data.pages.edges[2].node.PT.hero);
        setHeroMobile(result.data.pages.edges[2].node.PT.heromobile);
        setTypes(result.data.pages.edges[2].node.PT.type);
      })
      .then(() => organiseContent());
  }, []);

  function buttonCall() {
    const target = document.getElementById("paymentContent");
    target.scrollIntoView({ behavior: "smooth" });
  }

  let programmedWithdrawalsDisplay;
  let heroBannerDisplay;
  let heroMobileBannerDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="leadership-cover">
        <img
          id="payment-bg"
          className="leadership-bg"
          src={banner.image.mediaItemUrl}
        />
        <div className="leadership-content">
          <div id="payment-txt" className="abt-text ldr-txt">
            <h1 className="lead-h1 " data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p id="grey-p-payment" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {banner.caption}
            </p>
            <a
              id="btn-pym-withdrawal"
              className="btn-trns"
              onClick={buttonCall}
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) => (
      <div className="leadership-cover">
        <img
          id="payment-bg"
          className="leadership-bg"
          src={banner.image.mediaItemUrl}
        />
        <div className="leadership-content">
          <div id="payment-txt" className="abt-text ldr-txt">
            <h1 className="lead-h1" data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p id="grey-p-payment" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {banner.caption}
            </p>
            <a
              id="btn-pym-withdrawal"
              className="btn-trns"
              onClick={buttonCall}
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  function organiseContent(activeItem) {
    if (active === "Programmed Withdrawals (Lump Sum)") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "Programmed Withdrawals (Lump Sum)" ? (
          <div className="payment-type-content">
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }

    if (active === "Retiree Life Annuity (Lump Sum)") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "Retiree Life Annuity (Lump Sum)" ? (
          <div className="payment-type-content" data-aos="fade-up" data-aos-delay="200">
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }

    if (active === "En Bloc Payment") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "En Bloc Payment" ? (
          <div className="payment-type-content">
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }

    if (active === "Medical Grounds") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "Medical Grounds" ? (
          <div className="payment-type-content">
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }

    if (active === "Equity Withdrawal") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "25% Temporary Access (Equity Withdrawal)" ? (
          <div className="payment-type-content" >
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }

    if (active === "Foreigner Withdrawal") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "Foreigner Withdrawal" ? (
          <div className="payment-type-content">
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }

    if (active === "NSITF Transfer") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "NSITF Transfer" ? (
          <div className="payment-type-content">
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }

    if (active === "Legacy Funds") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "Legacy Funds" ? (
          <div className="payment-type-content">
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }

    if (active === "Additional Voluntary Contribution (AVC)") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "Additional Voluntary Contribution" ? (
          <div className="payment-type-content">
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }

    if (active === "Death Benefit") {
      programmedWithdrawalsDisplay = types.map((type, i) =>
        type.name === "Death Benefit" ? (
          <div className="payment-type-content">
            <h2 id="payment-mob" className="payment-h2" data-aos="fade-up" data-aos-delay="200">
              {type.name}
            </h2>
            <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {type.description}
            </p>
            <a
              href={type.link}
              id="dwn-btn-pym"
              className="dwn-btn d-flex align-items-center"
              data-aos="fade-up" data-aos-delay="200"
            >
              {" "}
              Download Form{" "}
              <img className="ms-2" src={Download} alt="Download" />
            </a>
            <div className="black-card" data-aos="fade-up" data-aos-delay="200">
              <h5 className="white-h5">Requirements</h5>
              <div className="requirements-list">
                {type.requirement.map((req, index) => (
                  <div className="d-flex align-items-start mt-2" key={index}>
                    <img src={Check} alt="Check" className="check-icon me-3" />{" "}
                    <p className="grey-p" key={index}>
                      {req.item}
                    </p>
                  </div>
                ))}
              </div>
              <p className="grey-p mt-4">
                <span style={{ color: "#FF7B20" }}>Note: </span>{" "}
                <i>Data recapture must be complete before processing.</i>
              </p>
            </div>
          </div>
        ) : (
          ""
        ),
      );
    }
  }

  if (types.length > 0) {
    organiseContent();
  }

  const paymentTypes = [
    {
      type: "Programmed Withdrawals (Lump Sum)",
      description:
        "This is the most common payment option for retirees under the Contributory Pension Scheme. It allows you to receive a portion of your pension savings as a lump sum upon retirement, while the remaining balance is paid to you in monthly or periodic withdrawals. It's a flexible and regulated structure that ensures your pension lasts throughout retirement.",
      buttonText: "Lump-Sum Form",
      requirements: "Private/Public",
      requirementsList: [
        "Official retirement letter.",
        "Appointment or employment evidence.",
        "Appointment or employment evidence.",
        "Confirmation of accrued pension rights.",
        "Age declaration/birth certificate.",
        "Enrollment proof with Leadway Pensure.",
        "Passport photo & valid ID.",
        "Proof of address (e.g. utility bill).",
      ],
    },
  ];

  const menuItems = [
    "Programmed Withdrawals (Lump Sum)",
    "Retiree Life Annuity (Lump Sum)",
    "En Bloc Payment",
    "Medical Grounds",
    "Equity Withdrawal",
    "Foreigner Withdrawal",
    "NSITF Transfer",
    "Legacy Funds",
    "Additional Voluntary Contribution (AVC)",
    "Death Benefit",
  ];
  return (
    <>
      <div className="leadership-container d-none d-sm-block">
        {heroBannerDisplay}
      </div>

      <div className="leadership-container d-block d-sm-none">
        {heroMobileBannerDisplay}
      </div>

      <div
        id="payment-types-section"
        class="containeer  mt-4"
        style={{ backgroundColor: "none" }}
      >
        <div className="side-rsp">
          <SideNav
            className={"payment-div"}
            items={menuItems}
            activeItem={active}
            onSelect={setActive}
            contentTrigger={organiseContent}
            types={true}
          />
          <Mobilenav
            className={""}
            items={menuItems}
            activeItem={active}
            onSelect={setActive}
          />

          <div className="rght-side flex-1 p-6" id="paymentContent">
            {active === "Programmed Withdrawals (Lump Sum)" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
            {active === "Retiree Life Annuity (Lump Sum)" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
            {active === "En Bloc Payment" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
            {active === "Medical Grounds" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
            {active === "Equity Withdrawal" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
            {active === "Foreigner Withdrawal" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
            {active === "NSITF Transfer" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
            {active === "Legacy Funds" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
            {active === "Additional Voluntary Contribution (AVC)" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
            {active === "Death Benefit" && (
              <div className="crd-div d-flex flex-wrap row-gap-5">
                {programmedWithdrawalsDisplay}
              </div>
            )}
          </div>
        </div>
      </div>
               <Footer/>
           <div className='height'> 

              </div>
    </>
  );
};

export default PaymentTypes;
